// extracted by mini-css-extract-plugin
module.exports = {"panel":"Collapse_panel__kAcAQ","showBtnContent":"Collapse_showBtnContent__3gwsw","content":"Collapse_content__2Nf5q"};